export const iconFontAwesomeMovingBoxArchive = (
	<i className="fa-solid fa-box-archive"></i>
);
